import { type ReactElement, useCallback } from 'react';
import { SelectField } from '@flos/react-ui';

import FormItem from 'components/FormItem/FormItem';
import { SelectChangeHandler } from '@flos/react-ui/build/core/forms/select/custom-select/custom-select-input';

/* ============================================ Local Types ============================================ */
type THandleOnChange = SelectChangeHandler;

type TSelect = (props: {
  className?: string;
  contentClassName?: string;
  label?: string;
  innerLabel?: string;
  value?: string;
  options: Array<{ value: string; label: string }>;
  isRequired?: boolean;
  onChange?: (value: string) => void;
}) => ReactElement;

/* ============================================ Main Component ============================================ */
const Select: TSelect = ({
  className,
  contentClassName,
  label,
  innerLabel = 'Vælg',
  value,
  options,
  isRequired,
  onChange = () => {}
}) => {
  const handleOnChange: THandleOnChange = useCallback(
    ({ value }) => {
      onChange(value);
    },
    [onChange]
  );

  return (
    <FormItem className={className} contentClassName={contentClassName} label={label} isRequired={isRequired}>
      <SelectField label={innerLabel} value={value} options={options} onSelectionChange={handleOnChange} />
    </FormItem>
  );
};

export default Select;
